import { useMutation, useQueryClient } from '@tanstack/react-query';

import { MERCHANDISING_COLLECTION_QUERY_KEY } from './useGetMerchandisingCollection';
import { MERCHANDISING_COLLECTIONS_QUERY_KEY } from './useGetMerchandisingCollections';
import { MERCHANDISING_COLLECTION_SLICES_QUERY_KEY } from './useGetMerchandisingCollectionSlices';

import MerchandisingCollectionsService, {
  CreateMerchandisingCollectionSliceDto,
} from '@/services/MerchandisingCollectionsService';

export function useCreateMerchandisingCollectionSlice() {
  const queryClient = useQueryClient();

  const { mutateAsync, isPending } = useMutation({
    mutationFn: ({
      collectionId,
      dto,
    }: {
      collectionId: number;
      dto: CreateMerchandisingCollectionSliceDto;
    }) => MerchandisingCollectionsService.createSlice(collectionId, dto),
    onSuccess: (_data, variables) => {
      const { collectionId } = variables;

      queryClient.invalidateQueries({
        queryKey: [...MERCHANDISING_COLLECTION_QUERY_KEY, collectionId],
      });

      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTIONS_QUERY_KEY,
      });

      queryClient.invalidateQueries({
        queryKey: MERCHANDISING_COLLECTION_SLICES_QUERY_KEY,
      });
    },
  });

  return {
    createMerchandisingCollectionSlice: mutateAsync,
    isLoading: isPending,
  };
}
